import React from 'react';

import { AuthProvider } from './auth';
import { CurrentUserProvider } from './currentUser';

const AppProvider = ({ children }) => (
  <AuthProvider>
    <CurrentUserProvider>
      {children}
    </CurrentUserProvider>
  </AuthProvider>
);

export default AppProvider;
